import axios from "axios";

export const APP_VIDEO_BY_IDX = '/api/' + process.env.REACT_APP_API_VERSION + '/app/media/';

export function getAppVideoByIdx(mediaIdx) {
    return axios.get(APP_VIDEO_BY_IDX + mediaIdx);
}